var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5202_15754)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.27647 17.8764H9.76482C14.2055 17.8764 17.8114 14.3388 17.8114 9.98212C17.8114 5.62549 14.2055 2.08789 9.76482 2.08789",
    fill: "#AA7C00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9875 15.9637L13.5518 15.9822L14.5288 14.98L16.0105 14.9575L14.9875 15.965V15.9637Z",
    fill: "#E7BB29"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5293 16.3433L13.0435 16.3605L12.2168 16.8649L13.9285 16.7375L14.5293 16.3433Z",
    fill: "#E7BB29"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0634 6.65576L15.5194 6.56815C15.3611 6.20045 14.782 5.35089 14.3571 4.88098L16.0106 5.00841C16.3597 5.46107 16.8266 6.19912 17.0634 6.65576Z",
    fill: "#F3E9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27666 17.8764C3.83266 17.8764 0.230087 14.342 0.230087 9.98212C0.230087 5.62226 3.83266 2.08789 8.27666 2.08789C12.7207 2.08789 16.3232 5.62226 16.3232 9.98212C16.3232 14.342 12.7207 17.8764 8.27666 17.8764Z",
    fill: "#ECD559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27666 17.8764C3.83266 17.8764 0.230087 14.342 0.230087 9.98212C0.230087 5.62226 3.83266 2.08789 8.27666 2.08789C12.7207 2.08789 16.3232 5.62226 16.3232 9.98212C16.3232 14.342 12.7207 17.8764 8.27666 17.8764Z",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.09304 9.98233C2.32711 3.70225 8.30759 3.38898 8.22099 3.38898C4.51093 3.38898 1.5004 6.34384 1.5004 9.98233C1.5004 13.6208 4.51229 16.5757 8.22099 16.5757C8.30759 16.5757 2.20399 16.2186 2.09304 9.98233Z",
    fill: "#A67705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27655 16.63C4.53423 16.63 1.50048 13.6537 1.50048 9.98225C1.50048 6.31078 4.53423 3.33447 8.27655 3.33447C12.0189 3.33447 15.0526 6.31078 15.0526 9.98225C15.0526 13.6537 12.0189 16.63 8.27655 16.63Z",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27647 17.8764H9.76483C14.2055 17.8764 17.8114 14.3388 17.8114 9.98212C17.8114 5.62549 14.2055 2.08789 9.76483 2.08789",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.76501 2.08789H8.27656",
    stroke: "#0B1420",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0055 1.0366C10.6361 0.627752 9.8472 0.371557 9.15168 0.560053",
    stroke: "black",
    strokeWidth: 0.78476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75181 1.40282C5.06168 0.94884 5.80726 0.590433 6.52307 0.686008",
    stroke: "black",
    strokeWidth: 0.78476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0017 10.7295C10.0017 10.7295 9.01396 11.3029 7.96805 11.2286C6.92215 11.1543 5.98854 10.8198 5.98854 10.8198C5.98854 10.8198 5.80724 12.1286 6.54194 13.3233C7.27665 14.518 7.94505 14.7344 8.63781 14.6202C9.33057 14.506 10.1695 13.7467 10.455 12.5441C9.98815 12.1233 9.75814 11.36 9.99898 10.7295H10.0017Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0344 10.6953C8.79909 11.3457 7.37568 11.3895 5.95228 10.8997C5.96175 11.2514 5.97663 11.5674 6.04023 11.8926C6.62339 12.4939 8.8018 12.482 9.94242 11.6815C9.83282 11.3643 9.89777 11.0789 10.0344 10.6953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.34968 13.8675C8.43628 13.6857 8.56213 13.4574 8.9383 13.3897C9.44167 13.2994 9.80566 13.6472 9.80566 13.6472C9.80566 13.6472 9.53503 14.4158 8.57701 14.5512C7.59733 14.6905 7.27664 13.9312 7.27664 13.9312C7.27664 13.9312 7.34565 13.6671 7.67852 13.5224C7.92073 13.4175 8.21978 13.456 8.49988 13.6074",
    fill: "#FF7EB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34968 13.8675C8.43628 13.6857 8.56213 13.4574 8.9383 13.3897C9.44167 13.2994 9.80566 13.6472 9.80566 13.6472C9.80566 13.6472 9.53503 14.4158 8.57701 14.5512C7.59733 14.6905 7.27664 13.9312 7.27664 13.9312C7.27664 13.9312 7.34565 13.6671 7.67852 13.5224C7.92073 13.4175 8.21978 13.456 8.49988 13.6074",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7428 9.98242C12.1244 9.52578 10.797 9.6041 10.207 10.4032C9.24898 11.6988 10.7807 13.1643 11.8024 13.3873",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0344 10.6952C8.50277 11.5421 6.8737 11.404 5.15804 10.4031",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4615 12.5456C10.2545 13.3872 9.59154 14.5885 8.40086 14.6203C6.60671 14.6695 5.81247 12.0226 6.00055 10.8265",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.01303 9.81495C5.95415 9.81495 5.09576 8.7547 5.09576 7.44681C5.09576 6.13893 5.95415 5.07867 7.01303 5.07867C8.07191 5.07867 8.9303 6.13893 8.9303 7.44681C8.9303 8.7547 8.07191 9.81495 7.01303 9.81495Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52551 9.26149C8.34013 9.07698 7.95313 8.72786 7.46871 8.65751C6.90174 8.57521 6.38619 8.75441 6.22381 9.18981C6.01272 9.75795 6.47279 10.4363 7.1859 10.6168C7.52013 10.7018 7.9193 10.6872 8.25759 10.5332",
    fill: "#ECD559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52551 9.26149C8.34013 9.07698 7.95313 8.72786 7.46871 8.65751C6.90174 8.57521 6.38619 8.75441 6.22381 9.18981C6.01272 9.75795 6.47279 10.4363 7.1859 10.6168C7.52012 10.7018 7.9193 10.6872 8.25759 10.5332",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75949 9.81495C8.70061 9.81495 7.84222 8.7547 7.84222 7.44681C7.84222 6.13893 8.70061 5.07867 9.75949 5.07867C10.8184 5.07867 11.6768 6.13893 11.6768 7.44681C11.6768 8.7547 10.8184 9.81495 9.75949 9.81495Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.68362 6.54169C9.19649 6.54169 8.80002 7.03018 8.80002 7.63284C8.80002 8.23549 9.19514 8.72398 9.68362 8.72398C10.1437 8.72398 10.4915 8.25142 10.5239 7.97266L9.74587 7.62089L10.5104 7.24788C10.4468 6.92 10.1139 6.54169 9.68362 6.54301V6.54169Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00039 6.36768C6.51326 6.36768 6.11679 6.85617 6.11679 7.45882C6.11679 8.06148 6.51191 8.54997 7.00039 8.54997C7.46046 8.54997 7.80822 8.07741 7.8407 7.79865L7.06264 7.44688L7.82717 7.07387C7.76357 6.74599 7.43069 6.36768 7.00039 6.369V6.36768Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5202_15754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.4f40bdf38cdc3ac5e13711c2d0efb2d9.svg";
export { ForwardRef as ReactComponent };